import { render, staticRenderFns } from "./CurriculumUpload.vue?vue&type=template&id=25b58f19&"
import script from "./CurriculumUpload.vue?vue&type=script&lang=js&"
export * from "./CurriculumUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports